/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Export_Csv_TitleInputs */

const en_knp_terms_export_csv_title = /** @type {(inputs: Knp_Terms_Export_Csv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export terms to CSV`)
};

const fr_knp_terms_export_csv_title = /** @type {(inputs: Knp_Terms_Export_Csv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter les termes en CSV`)
};

const de_knp_terms_export_csv_title = /** @type {(inputs: Knp_Terms_Export_Csv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begriffe in CSV exportieren`)
};

const it_knp_terms_export_csv_title = /** @type {(inputs: Knp_Terms_Export_Csv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta i termini in CSV`)
};

const ru_knp_terms_export_csv_title = /** @type {(inputs: Knp_Terms_Export_Csv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт терминов в CSV`)
};

const es_knp_terms_export_csv_title = /** @type {(inputs: Knp_Terms_Export_Csv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar términos a CSV`)
};

const zh_cn2_knp_terms_export_csv_title = /** @type {(inputs: Knp_Terms_Export_Csv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出条款至 CSV 文件`)
};

const ja_knp_terms_export_csv_title = /** @type {(inputs: Knp_Terms_Export_Csv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用語をCSVにエクスポート`)
};

const hi_knp_terms_export_csv_title = /** @type {(inputs: Knp_Terms_Export_Csv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शर्तों को CSV में निर्यात करें`)
};

const pt_pt2_knp_terms_export_csv_title = /** @type {(inputs: Knp_Terms_Export_Csv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar termos para CSV`)
};

/**
* | output |
* | --- |
* | "Export terms to CSV" |
*
* @param {Knp_Terms_Export_Csv_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_export_csv_title = /** @type {((inputs?: Knp_Terms_Export_Csv_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Export_Csv_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_export_csv_title(inputs)
	if (locale === "de") return de_knp_terms_export_csv_title(inputs)
	if (locale === "it") return it_knp_terms_export_csv_title(inputs)
	if (locale === "ru") return ru_knp_terms_export_csv_title(inputs)
	if (locale === "es") return es_knp_terms_export_csv_title(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_export_csv_title(inputs)
	if (locale === "ja") return ja_knp_terms_export_csv_title(inputs)
	if (locale === "hi") return hi_knp_terms_export_csv_title(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_export_csv_title(inputs)
	return en_knp_terms_export_csv_title(inputs)
});